<template>
  <v-card
      color="grey lighten-4"
      light
  >
    <v-card-text>
      <content-section
          id="timeline"
          :title="detailed ? 'Detailed Experiences' : 'Experiences'"
      >
        <template slot="actions">
          <div>
            <v-switch
                v-model="detailed"
                :label="detailed ? 'Detailed' : 'Summary'"
            />
          </div>
        </template>

        <v-timeline
            dense
        >
          <v-timeline-item
              v-for="(item, i) in orderedItems"
              :key="i"
              :icon="item.icon || ''"
              :class="{transparent: item.transparent}"
              large
          >
            <template
                v-if="item.iconImage"
                v-slot:icon
            >
              <v-avatar>
                <img
                    :src="publicPath(item.iconImage)"
                >
              </v-avatar>
            </template>
            <template v-slot:opposite/>
            <v-layout>
              <v-flex
                  v-if="$vuetify.breakpoint.smAndUp"
                  md1
                  sm2
                  align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                  md11
                  sm10
                  xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                      <h5 v-if="item.company">{{ item.company }}</h5>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                          :md7="!!item.image"
                          :md12="!item.image"
                          xs12
                      >
                        <div class="mr-1">
                          <span
                              v-if="item.text"
                              class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                              v-else-if="item.html"
                              v-html="item.html"
                          />
                          <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                          v-if="item.image"
                          md5
                          xs12
                      >
                        <div
                            class="mt-2"
                        >
                          <v-carousel
                              v-if="Array.isArray(item.image)"
                              :show-arrows="false"
                              :height="325"
                          >
                            <v-carousel-item
                                v-for="(citem,ci) in item.image"
                                :key="ci"
                                :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                              v-else
                              :max-height="item.imageHeight ? item.imageHeight : ''"
                              :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'

export default {
  name      : 'Timeline',
  components: { ContentSection },
  data      : () => ({
    detailed: true,
    items   : [
      {
        detailed: false,
        year    : '2021',
        company : 'Eden Farm',
        title   : 'Vice President Of Engineering',
        html    : `Promoting Tech as business support
                    <ul>
                    <li>Translates all company's divisions KPIs into concrete implementation</li>
                    <li>Promote SCRUM to improve the quality and value of products released</li>
                    <li>Improve Tech Team readiness for future development</li>
                    <li>Strengthen Tech Team as a support team to help other divisions reach their KPIs</li>
                    <li>Bridge the gap between Tech Team and Internal/External Stakeholders</li>
                    <li>Improve the scalability of the tech stack built using Golang, VueJS, and React Native</li>
                    <li>Intense focus on all products security</li>
                    <li>Improve CI/CD processes and environment</li>
                    </ul>
                    … And have so much fun doing it!`,
        iconImage: 'img/timeline/edenfarm.jpg',
      },
    ],
  }),
  computed  : {
    orderedItems () {
      const items = [...this.items].reverse()
      if (this.detailed) {
        return items
      }
      return items.filter((item) => {
        return !item.detailed
      })
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}

.pre {
  white-space: pre;
}

.transparent {
  opacity: 0.6;
}
</style>
